import React from 'react';

// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import styled from 'styled-components';

import { token } from '@atlaskit/tokens';

import RecentWorkSkeletonGroupedHeading from './recent-work-skeleton-grouped-heading';
import RecentWorkSkeletonRow from './recent-work-skeleton-row';

const RecentWorkSkeletonPanel = (): React.JSX.Element => {
	return (
		<RecentWorkWrapper data-testid="recent-work-tab-content-loading">
			<Grouping>
				<RecentWorkSkeletonGroupedHeading />

				<RecentWorkSkeletonRow hasAvatar />
				<RecentWorkSkeletonRow hasAvatar />
				<RecentWorkSkeletonRow hasAvatar />
				<RecentWorkSkeletonRow hasAvatar />
			</Grouping>
		</RecentWorkWrapper>
	);
};

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/design-system/no-styled-tagged-template-expression -- Ignored via go/DSP-18766
const RecentWorkWrapper = styled.div`
	width: 100%;
`;

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/design-system/no-styled-tagged-template-expression -- Ignored via go/DSP-18766
const Grouping = styled.div`
	margin-top: ${token('space.250', '20px')};
`;

export default RecentWorkSkeletonPanel;
